module.exports = __webpack_public_path__ + "img/logo-abstract.d7a8a76c.svg";